module.exports = __webpack_public_path__ + "img/scanner-for-business-hr.039061e7.png";